// removed by extract-text-webpack-plugin
module.exports = {"vpAuthTypeButton":"vpAuthTypeButton___2Kvsw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/Login.module.less
// module id = 2166
// module chunks = 30